// Salesforce accounts of the ICS entities, whose costs carry ICS's profit share.
const ICS_SOURCE_SUPPLIER_IDS = new Set([
  '0010I00002J0Bb0QAF', // ICS Thailand
  '0010I000026fcwcQAA', // ICS Travel Group
  '001Ii000002ZfiKIAS', // ICS Travel Group (ZAR)
  '001RF00000dKZKxYAO', // ICS Travel Group Malaysia MYR
  '0012y00000W105xAAB', // ICS Vietnam
  '001RF00000SebvFYAR', // ICS India
  '001RF00000SeflyYAB', // ICS Morocco
]);

// ICS keeps 12% of what it is paid, so the base cost is grossed up to leave it whole.
export const ICS_COST_SHARE = 0.88;

/** ICS's share on top of a base cost; undefined for a supplier it does not apply to. */
export function icsProfitShare(
  sourceSupplierId: string | null | undefined,
  baseCost: number | null,
): number | null | undefined {
  if (!sourceSupplierId || !ICS_SOURCE_SUPPLIER_IDS.has(sourceSupplierId)) {
    return undefined;
  }

  return baseCost === null ? null : baseCost / ICS_COST_SHARE - baseCost;
}

export function withProfitShare(baseCost: number | null, profitShare: number | null | undefined): number | null {
  return baseCost === null ? null : baseCost + (profitShare ?? 0);
}
